import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  FormControlLabel,
  Tooltip,
  Switch,
   Box,
   
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import servicefaretypeapi from "Services/ZoneServicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ServiceUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState();
  const [addedzone , setaddedzone] = useState([]);  
  const [addedservicetype , setaddedservicetype] = useState([]);  







  // Fetch serivefare Details
  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        console.log("fetched data from update page--->",res.data?.data);
        setDetails(res.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    servicefaretypeapi.getzoneServicefarebyid(id).then(onSuccess, onFailure);
  }, [id]);

   // Get Services list api
  const getServicetype = useCallback(() => {
  dispatch(showLoader("Loading please wait..."));
  const onSuccess = (res) => {
  //console.log('res.data--->',res.data);
  dispatch(hideLoader());
  if (res?.status === 200) {
    console.log('res?.data-->',res?.data)
    const zoneOptions = res?.data?.data?.data?.addedzone;
    const serviceOptions = res?.data?.data?.data?.services;
    setaddedzone(Array.isArray(zoneOptions) ? zoneOptions : []);
    setaddedservicetype(Array.isArray(serviceOptions) ? serviceOptions : []);
  } else {
    setaddedzone([]);
    setaddedservicetype([]);
  }
  };
  const onFailure = (err) => {
  dispatch(hideLoader());
  dispatch(
    showSnackbar({
      message: err?.response?.data?.message || "Failed to fetch data",
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      variant: "error",
    })
  );
  setaddedzone([]);
  setaddedservicetype([]);
  //console.log("error fetch service area", err);
  };
  servicefaretypeapi.getexcludedzoneServicesList()
  .then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
    getServicetype();
  }, [openDialog]);

  const formatTime = (time) => {
    if (time && time.$isDayjsObject) {
      return dayjs(time).format("hh:mm:ss A");
    }
    return "Invalid Time";
  };  

  const handleUpdateServicetype = (formValues) => {
  // console.log("here");
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;
    
    formValues.Daystartingtime = formatTime(formValues.daystartingtime)
    formValues.Nightstartingtime = formatTime(formValues.nightstartingtime)
    formValues.Dayendingtime = formatTime(formValues.dayendingtime)
    formValues.Nightendingtime = formatTime(formValues.nightendingtime)
     formValues.DaystartingtimeWeekend = formValues.daystartingtimeWeekend != null ? formatTime(formValues.daystartingtimeWeekend) : null
  formValues.NightstartingtimeWeekend =formValues.nightstartingtimeWeekend != null ?  formatTime(formValues.nightstartingtimeWeekend) :null
  formValues.DayendingtimeWeekend =  formValues.dayendingtimeWeekend != null ? formatTime(formValues.dayendingtimeWeekend) :null
  formValues.NightendingtimeWeekend =  formValues.nightendingtimeWeekend != null ? formatTime(formValues.nightendingtimeWeekend) : null
    
    formValues.dayRange = "MONDAY-SUNDAY"

    //console.log('formValues-->', formValues);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Service fare Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update service details api error", err);
    };

    if (validatationPass) {
      servicefaretypeapi.updatezoneServicefare(id, { ...formValues }).then(onSuccess, onFailure);
    }
  };

  const timeToString = (time) => {
    if (!time || typeof time !== "object") return ""; // Handle invalid inputs
    const hour = time.hour.toString().padStart(2, "0");
    const minutes = time.minutes.toString().padStart(2, "0");
    return `${hour}:${minutes} ${time.Median}`;
  };
    
  const timeToDayjs = (time) => {
    const timeString = timeToString(time);
    //console.log("Generated timeString:", timeString); // Debug log
    return dayjs(timeString, "hh:mm A");
  };
  
    // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
      if (!_.isEmpty(details)) {
        //console.log("details ", details);
        formik.setFieldValue("servicetypes", details?.zoneserviceTypeId._id);
      
        formik.setFieldValue("daystartingtime", timeToDayjs(details?.daytime.startingTime));        
        formik.setFieldValue("nightstartingtime", timeToDayjs(details?.nighttime.startingTime));
        formik.setFieldValue("dayendingtime", timeToDayjs(details?.daytime.endingTime));
        formik.setFieldValue("nightendingtime", timeToDayjs(details?.nighttime.endingTime));
        formik.setFieldValue("daybaseprice", details?.daytime.basePrice);
        formik.setFieldValue("nightbaseprice", details?.nighttime.basePrice);
     
     
        formik.setFieldValue("daystartingtimeWeekend", timeToDayjs(details?.daytimeWeekend.startingTime));        
        formik.setFieldValue("nightstartingtimeWeekend", timeToDayjs(details?.nighttimeWeekend.startingTime));
        formik.setFieldValue("dayendingtimeWeekend", timeToDayjs(details?.daytimeWeekend.endingTime));
        formik.setFieldValue("nightendingtimeWeekend", timeToDayjs(details?.nighttimeWeekend.endingTime));
        formik.setFieldValue("daybasepriceWeekend", details?.daytimeWeekend.basePrice);
        formik.setFieldValue("nightbasepriceWeekend", details?.nighttimeWeekend.basePrice);
   
        formik.setFieldValue("ReverseLocation", details?.ReverseLocation);
        formik.setFieldValue("DestinationAddress", details?.DestinationAddress?._id);
        formik.setFieldValue("SourceAddress", details?.SourceAddress._id);             
      }
      
    };

    console.log(details)
    updateFormValues();
  }, [details]);

  console.log(details)

  // Formik

  const formik = useFormik({
    initialValues: {
       servicetypes:"",
     
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
       daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice:"",
      nightbaseprice:"",
      daybasepriceWeekend:"",
      nightbasepriceWeekend:"",
       ReverseLocation:false,
      SourceAddress:"",
      DestinationAddress:"",
    
      // farezone: false,
     
      // zonepercentage: 0,            
    },
    validationSchema: yup.object({
   servicetypes: yup.string().required("service types is required").nullable(),
      
       daystartingtime: yup.string().required("Day starting time is required").nullable(),
       nightstartingtime: yup.string().required("Night starting time is required").nullable(),
       dayendingtime: yup.string().required("Day starting time is required").nullable(),
       nightendingtime: yup.string().required("Night ending time is required").nullable(),
       daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
       nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
       dayendingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
       nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
       daybaseprice: yup
         .number()
         .typeError("Day base price must be a number")
         .required("Day base price is required"),
       nightbaseprice: yup
         .number()
         .typeError("Night base price must be a number")
         .required("Night base price is required"),
   
        SourceAddress: yup
         .string()
         .required("Day Source Address is required").nullable(),
   
        DestinationAddress: yup
         .string()
         .required("Day Destination Address is required").nullable(),
       
       daybasepriceWeekend: yup
         .number()
         .typeError("Day base price must be a number")
         .required("Day base price is required"),
       nightbasepriceWeekend: yup
         .number()
         .typeError("Night base price must be a number")
         .required("Night base price is required"),
      
   
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateServicetype,
  });

  const zoneOptions = Array.isArray(addedzone) ? addedzone : [];
  const serviceTypeOptions = Array.isArray(addedservicetype)
    ? addedservicetype
    : [];

  //Tabs

  return (
    <>
<Dialog
open={openDialog}
TransitionComponent={Transition}
keepMounted
onClose={handleClose}
maxWidth={"xl"}
aria-describedby="dialog-box"
className={classes.root}
>
<DialogTitle>
<section className={classes.dialogTitleContainer}>
<Typography variant="body1" className={classes.title}>
  Update zone Fare model
</Typography>
<IconButton aria-label="close" onClick={handleClose}>
  <CloseIcon className={classes.closeIcon} />
</IconButton>
</section>
</DialogTitle>

<DialogContent>

<Grid container spacing={3} rowSpacing={4} columnSpacing={4} className={classes.detailsContainer} >





<Grid item xs={12}>
  <Typography  variant="h4">
Add Location Wise Fare
  </Typography>
</Grid>

 <Grid container  spacing={3} rowSpacing={4} columnSpacing={3} style={{ padding: 40}}>
  <Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Source Address : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="SourceAddress"
id="SourceAddress"
label="Source Address"
value={formik?.values?.SourceAddress}
defaultValue={formik?.values?.SourceAddress}
onChange={formik.handleChange}
select
error={
formik?.errors?.SourceAddress &&
formik?.touched?.SourceAddress
}
helperText={
formik?.errors?.SourceAddress &&
formik?.touched?.SourceAddress &&
formik?.errors?.SourceAddress
}
fullWidth
variant="outlined"
size="small"
>
 {zoneOptions.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Grid>


<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Destination Address : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="DestinationAddress"
id="DestinationAddress"
label="Destination Address"
value={formik?.values?.DestinationAddress}
defaultValue={formik?.values?.DestinationAddress}
onChange={formik.handleChange}
select
error={
formik?.errors?.DestinationAddress &&
formik?.touched?.DestinationAddress
}
helperText={
formik?.errors?.DestinationAddress &&
formik?.touched?.DestinationAddress &&
formik?.errors?.DestinationAddress
}
fullWidth
variant="outlined"
size="small"
>
 {zoneOptions.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Grid>

<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Service Types : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="servicetypes"
id="servicetypes"
label="Service Types"
value={formik?.values?.servicetypes}
defaultValue={formik?.values?.servicetypes}
onChange={formik.handleChange}
select
error={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes
}
helperText={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes &&
formik?.errors?.servicetypes
}
fullWidth
variant="outlined"
size="small"
>
{serviceTypeOptions.map((service) => (
<MenuItem
  key={service.serviceName}
  value={service._id}
>
  {`${service.serviceName}`}
</MenuItem>
))}
</TextField>
</Grid>

<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Reverse Location : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="ReverseLocation"
id="ReverseLocation"
label="Reverse Location"
value={formik?.values?.ReverseLocation}
defaultValue={formik?.values?.ReverseLocation}
onChange={formik.handleChange}
select
error={
formik?.errors?.ReverseLocation &&
formik?.touched?.ReverseLocation
}
helperText={
formik?.errors?.ReverseLocation &&
formik?.touched?.ReverseLocation &&
formik?.errors?.ReverseLocation
}
fullWidth
variant="outlined"
size="small"
>

<MenuItem
  value={false}
>
 No
</MenuItem>
<MenuItem
  value={true}
>
 Yes
</MenuItem>

</TextField>
</Grid>



 </Grid>



</Grid>

<Grid container spacing={3} rowSpacing={4} columnSpacing={3} className={classes.tarrifContainer}>

<Grid item xs={12}>


       
  <Grid item xs={12} style={{paddingTop:40,paddingBottom:40}}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"MONDAY - THURSDAY TARIFF"}</Typography>
</Grid>
<Grid container spacing={3} rowSpacing={4} columnSpacing={3}>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.daystartingtime}
            onChange={(newValue) => formik.setFieldValue("daystartingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime
              }
              helperText={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime &&
              formik?.errors?.daystartingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightstartingtime}
            onChange={(newValue) => formik.setFieldValue("nightstartingtime", newValue)}
            renderInput={(params) => <TextField {...params}  
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime
              }
              helperText={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime &&
              formik?.errors?.nightstartingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.dayendingtime}
            onChange={(newValue) => formik.setFieldValue("dayendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime
              }
              helperText={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime &&
              formik?.errors?.dayendingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightendingtime}
            onChange={(newValue) => formik.setFieldValue("nightendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime
              }
              helperText={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime &&
              formik?.errors?.nightendingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
</Grid>
  <Grid item xs={4}>
  <TextField
name="daybaseprice"
id="daybaseprice"
label="Base price"
value={formik?.values?.daybaseprice}
defaultValue={formik?.values?.daybaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice
}
helperText={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice &&
formik?.errors?.daybaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightbaseprice"
id="nightbaseprice"
label="Base price"
value={formik?.values?.nightbaseprice}
defaultValue={formik?.values?.nightbaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice
}
helperText={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice &&
formik?.errors?.nightbaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

 

 

</Grid>

      
           <Grid item xs={12} style={{paddingTop:50,paddingBottom:50}}>
          <Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"FRIDAY - SUNDAY TARIFF"}</Typography>
          </Grid>

          <Grid container spacing={3} rowSpacing={4} columnSpacing={3}>
          
          <Grid item xs={4}>
          <Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
          </Grid>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid item xs={4}>
          <Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
          <TimePicker
                      ampm={true} // Enables AM/PM selection
          
                      value={formik?.values?.daystartingtimeWeekend}
                      onChange={(newValue) => formik.setFieldValue("daystartingtimeWeekend", newValue)}
                      renderInput={(params) => <TextField {...params} 
                      fullWidth 
                      variant="outlined"
                      error={
                        formik?.errors?.daystartingtimeWeekend &&
                        formik?.touched?.daystartingtimeWeekend
                        }
                        helperText={
                        formik?.errors?.daystartingtimeWeekend &&
                        formik?.touched?.daystartingtimeWeekend &&
                        formik?.errors?.daystartingtimeWeekend
                        }
                      size="small" />}
                    />
          </Grid>
          <Grid item xs={4}>
          <Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
          <TimePicker
                      ampm={true} // Enables AM/PM selection
                      value={formik?.values?.nightstartingtimeWeekend}
                      onChange={(newValue) => formik.setFieldValue("nightstartingtimeWeekend", newValue)}
                      renderInput={(params) => <TextField {...params}  
                      fullWidth 
                      variant="outlined"
                      error={
                        formik?.errors?.nightstartingtimeWeekend &&
                        formik?.touched?.nightstartingtimeWeekend
                        }
                        helperText={
                        formik?.errors?.nightstartingtimeWeekend &&
                        formik?.touched?.nightstartingtimeWeekend &&
                        formik?.errors?.nightstartingtimeWeekend
                        }
                      size="small" />}
                    />
          </Grid>
          </LocalizationProvider>
          
          <Grid item xs={4}>
          <Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
          </Grid>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid item xs={4}>
          <TimePicker
                      ampm={true} // Enables AM/PM selection
                      value={formik?.values?.dayendingtimeWeekend}
                      onChange={(newValue) => formik.setFieldValue("dayendingtimeWeekend", newValue)}
                      renderInput={(params) => <TextField {...params} 
                      fullWidth 
                      variant="outlined"
                      error={
                        formik?.errors?.dayendingtimeWeekend &&
                        formik?.touched?.dayendingtimeWeekend
                        }
                        helperText={
                        formik?.errors?.dayendingtimeWeekend &&
                        formik?.touched?.dayendingtimeWeekend &&
                        formik?.errors?.dayendingtimeWeekend
                        }
                      size="small" />}
                    />
          </Grid>
          <Grid item xs={4}>
          <TimePicker
                      ampm={true} // Enables AM/PM selection
                      value={formik?.values?.nightendingtimeWeekend}
                      onChange={(newValue) => formik.setFieldValue("nightendingtimeWeekend", newValue)}
                      renderInput={(params) => <TextField {...params} 
                      fullWidth 
                      variant="outlined"
                      error={
                        formik?.errors?.nightendingtimeWeekend &&
                        formik?.touched?.nightendingtimeWeekend
                        }
                        helperText={
                        formik?.errors?.nightendingtimeWeekend &&
                        formik?.touched?.nightendingtimeWeekend &&
                        formik?.errors?.nightendingtimeWeekend
                        }
                      size="small" />}
                    />
          </Grid>
          </LocalizationProvider>
          
          <Grid item xs={4}>
          <Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
          </Grid>
            <Grid item xs={4}>
            <TextField
          name="daybasepriceWeekend"
          id="daybasepriceWeekend"
          label="Base price"
          value={formik?.values?.daybasepriceWeekend}
          defaultValue={formik?.values?.daybasepriceWeekend}
          onChange={formik.handleChange}
          error={
          formik?.errors?.daybasepriceWeekend &&
          formik?.touched?.daybasepriceWeekend
          }
          helperText={
          formik?.errors?.daybasepriceWeekend &&
          formik?.touched?.daybasepriceWeekend &&
          formik?.errors?.daybasepriceWeekend
          }
          fullWidth
          variant="outlined"
          size="small"
          ></TextField>
            </Grid>
            <Grid item xs={4}>
            <TextField
          name="nightbasepriceWeekend"
          id="nightbasepriceWeekend"
          label="Base price"
          value={formik?.values?.nightbasepriceWeekend}
          defaultValue={formik?.values?.nightbasepriceWeekend}
          onChange={formik.handleChange}
          error={
          formik?.errors?.nightbasepriceWeekendWeekend &&
          formik?.touched?.nightbasepriceWeekendWeekend
          }
          helperText={
          formik?.errors?.nightbasepriceWeekendWeekend &&
          formik?.touched?.nightbasepriceWeekendWeekend &&
          formik?.errors?.nightbasepriceWeekendWeekend
          }
          fullWidth
          variant="outlined"
          size="small"
          ></TextField>
            </Grid>
      
         
          
               </Grid>

        


</Grid>




{/* Add Fare button */}      
<Grid item xs={12} className={classes.sbtBtnWrapper}>
<Button variant="contained" onClick={formik?.handleSubmit} >
Update Fare Model
</Button>
</Grid>

</Grid>

</DialogContent>

<Divider />
<DialogActions>
<section className={classes.dialogActions}>
<section className={classes.closeBtn}>
<Button onClick={handleClose}>Close</Button>
</section>
</section>
</DialogActions>
</Dialog>
    </>
  );
};

export default ServiceUpdate;
